import Header from "./components/Header"
import Main from "./pages/Main"
import Directories from "./pages/Directories"
import { useFilesProvider } from "./fmanlibs/FilesProvider"
import Resizer from "./gui/Resizer/Resizer"
import Footer from "./components/Footer"
import Loading from "./gui/Loading/Loading"
import MainToolbar from "./components/MainToolbar"

export default function App() {
    const {files} = useFilesProvider()
    return <div id="main" className="flex1">
        <Header/>
        <div className="body flex1 flex">
            <Resizer min={64} max={300}><Directories/></Resizer>
            { files ? <div id="main" className="flex1"><MainToolbar/><Main/></div> : <Loading className="large"/> }
        </div>
        <Footer/>
    </div>
}